import './Error.scss'

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { ERROR_MESSAGE_TYPE_BOARD_PERMSSIONS } from '../../constants/errorMessageTypes'

class Error extends Component {
  mapErrorMessage = (errorType) => {
    switch (errorType) {
      case ERROR_MESSAGE_TYPE_BOARD_PERMSSIONS:
        return this.props.localize('taskBoards.Msg_NoPermissionToViewBoardForWorkspace')
      default:
        return this.props.localize('taskBoards.Msg_UnexpectedError')
    }
  }
  render() {
    const message = this.mapErrorMessage(this.props.params.errorType)
    return (
      <div className='error-message-container'>
        {message}
      </div>
    )
  }
}

Error.propTypes = {
  localize: PropTypes.func.isRequired
}

export default Error



// WEBPACK FOOTER //
// ./src/routes/Error/Error.js